<template>
  <div class="layout">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  name: 'LoginLayout'
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/common

body
  margin: 0px
  padding: 0px
  width: 100%
  height: 100%

.layout
  min-height: 100vh
  width: 100%
</style>
